/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AppVersionResponse = core.serialization.object({
    commit: core.serialization.string(),
    version: core.serialization.string(),
});
